import { MOBILE_MAX_WIDTH } from '@authFlow/App/variables';
import { isFeatureFlagActive } from '@authFlow/utils/experiments/isFeatureFlagActive';

const isDesktopRecommendedStepRequired = (): boolean => {
  const isMobile = window.matchMedia(MOBILE_MAX_WIDTH).matches;

  return isFeatureFlagActive('mobile_flow_exp') && isMobile;
};

export default isDesktopRecommendedStepRequired;
